import {
  ApplicationConfigurationStore,
  IApplicationConfigurationModel,
  ICommonAppState,
} from "@xala/common-services";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { ApplicationConfigurationDetailsForm as ApplicationConfigurationDetailsFormDefinition } from "./ApplicationConfigurationDetailsForm";

const mapStateToProps = (state: ICommonAppState) => {
  return {
    actionType: state.applicationConfiguration.actionType,
    isProcessingData: state.applicationConfiguration.isProcessingData,
    error: state.applicationConfiguration.error,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateConfiguration: (data: IApplicationConfigurationModel) => {
    return dispatch(
      ApplicationConfigurationStore.Actions.updateConfiguration(data)
    );
  },
});

export const ApplicationConfigurationDetailsForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ApplicationConfigurationDetailsFormDefinition));
